import { useQuery } from "react-query";
import { api } from "../../utils/api";

export const getRemittanceReturn = async () => {
  try {
    const response = await api.get(`financial-remittance-return`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const useQueryGetRemittanceReturn = () => {
  return useQuery(["financialReturn"], () => getRemittanceReturn());
};
